module.exports.MINIMUM_SUPPORTED_YEAR = 1789;
